import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EndUserType } from "../types/EndUserType";
import { apiClient } from "src/utils/Api/apiClient";

interface endUserState {
        endUser: EndUserType;
        endUserLoading: boolean;
        endUserError: string | null;
}

const initialState: endUserState = {
        endUser: {
                Id: 0,
                EndUserId: "",
                DealerId: 0,
                Name: "",
                Addresses: {
                        Address1: "",
                        Address2: "",
                        City: "",
                        State: "",
                        Country: "",
                        PostalCode: "",
                        AddressType: ""
                },
                EmailId: "",
                Enabled: false,
                PhoneNumber: "",
                TotalNumberOfDoors: 0,
                Notes: "",
                PrimaryContactEmail: "",
                PrimaryContactPhone: "",
                CreatedAt: "",
                ModifiedAt: "",
        },
        endUserLoading: false,
        endUserError: null
}

export const createEndUser = createAsyncThunk(
        'endUser/createEndUser',
        async (endUserData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('endUser/createEndUser', endUserData);
                        return response.data;
                } catch (error: any) {
                        return rejectWithValue(error.response.data || 'An error occured');
                }
        }
);

export const updateEndUser = createAsyncThunk(
        'endUser/updateEndUser',
        async (endUserData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('endUser/updateEndUser', endUserData).then();
                        return response.data;
                } catch (error: any) {
                        return rejectWithValue(error.response.data || 'An error occured');
                }
        }
);

export const moveEndUser = createAsyncThunk(
        'endUser/moveEndUser',
        async (endUserData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('endUser/moveEndUser', endUserData).then();
                        return response.data;
                } catch (error: any) {
                        return rejectWithValue(error.message || 'An error occured');
                }
        }
);

export const getEndUserById = createAsyncThunk(
        'endUser/getEndUserById',
        async (endUserData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`endUser/getEndUserByID/${endUserData}`);
                        return response.data;
                } catch (error: any) {
                        return rejectWithValue(error.message || 'An error occured');
                }
        }
);

const endUserSlice = createSlice({
        name: 'endUser',
        initialState,
        reducers: {
                endUserReset: () => initialState,
        },
        extraReducers: (builder) => {
                //add endUsers to server
                builder.addCase(createEndUser.pending, (state) => {
                        state.endUserLoading = true;
                        state.endUserError = null;
                });
                builder.addCase(createEndUser.fulfilled, (state, action) => {
                        state.endUserLoading = false;
                        state.endUser = action.payload;
                });
                builder.addCase(createEndUser.rejected, (state, action) => {
                        state.endUserLoading = false;
                        state.endUserError = action.payload as string;
                });
                //update endUsers to server
                builder.addCase(updateEndUser.pending, (state) => {
                        state.endUserLoading = true;
                        state.endUserError = null;
                });
                builder.addCase(updateEndUser.fulfilled, (state, action) => {
                        state.endUserLoading = false;
                        state.endUser = action.payload;
                });
                builder.addCase(updateEndUser.rejected, (state, action) => {
                        state.endUserLoading = false;
                        state.endUserError = action.payload as string;
                });
                //move endUsers to server
                builder.addCase(moveEndUser.pending, (state) => {
                        state.endUserLoading = true;
                        state.endUserError = null;
                });
                builder.addCase(moveEndUser.fulfilled, (state, action) => {
                        state.endUserLoading = false;
                        state.endUser = action.payload;
                });
                builder.addCase(moveEndUser.rejected, (state, action) => {
                        state.endUserLoading = false;
                        state.endUserError = action.payload as string;
                });
                //getEndUserById to server
                builder.addCase(getEndUserById.pending, (state) => {
                        state.endUserLoading = true;
                        state.endUserError = null;
                });
                builder.addCase(getEndUserById.fulfilled, (state, action) => {
                        state.endUserLoading = false;
                        state.endUser = action.payload;
                });
                builder.addCase(getEndUserById.rejected, (state, action) => {
                        state.endUserLoading = false;
                        state.endUserError = action.payload as string;
                });
        }
});

export const { endUserReset } = endUserSlice.actions;
export default endUserSlice.reducer;
